module.exports = __webpack_public_path__ + "img/vue-calc.9b1a9b20.png";